// Environment variables are inserted at run time. This is favoured over
// including them during build time as the built docker image - including the
// build artifact - is identical regardless of the environment where it is used.
// This means that the image is identical and can freely be moved between
// environments without the needs of additional builds.

// The variables are sourced in index.html from /env.js and are stored on the
// window object. Docker containers generate /env.js during startup based on
// available environment variables. Local dev envs uses /public/env.js
// (which is source controlled).

interface Env {
  NAME: string;
  KEYCLOAK_URL: string;
  KEYCLOAK_REALM: string;
  SAM_URL: string;
  GOOGLEANALYTICS_ENABLED: boolean;
  GOOGLEANALYTICS_TAGID: string;
}

const env: Env = {
  // @ts-expect-error - window._env is set globally at runtime
  ...window._env,
  // @ts-expect-error - window._env is set globally at runtime
  GOOGLEANALYTICS_ENABLED: window._env?.GOOGLEANALYTICS_ENABLED === 'true',
};

export default env;

enum Environment {
  DEV = 'DEV',
  TEST = 'TEST',
  PROD = 'PROD',
}

const getEnv = () => {
  const url = window.location.href;
  if (process.env.NODE_ENV === 'production') {
    if (url.includes('test.plantdesigner')) {
      return Environment.TEST;
    }
    return Environment.PROD;
  }
  return Environment.DEV;
};

const isEnv = (env: Environment) => () => getEnv() === env;
export const isDev = isEnv(Environment.DEV);
export const isTest = isEnv(Environment.TEST);
export const isProd = isEnv(Environment.PROD);
export const isDevOrTest = () => isDev() || isTest();

export const getSentryEnvironment = () => {
  if (isTest()) {
    return 'test';
  }

  if (isProd()) {
    return 'production';
  }

  return 'development';
};
